{
  "notFound": {
    "title": "PÁGINA NO ENCONTRADA",
    "msg": "Lo sentimos, la página solicitada no fue encontrada.",
    "goHomeBtn": "Ir al inicio"
  },
  "notAvailable": {
    "title": "PÁGINA NO DISPONIBLE",
    "msg": "Lo sentimos, la página solicitada no está disponible."
  },
  "validatorService": {
    "minLength": "Mínimo de caracteres permitido:",
    "maxLength": "Máximo de caracteres permitido:",
    "required": "Campo requerido",
    "invalidEmail": "Email inválido"
  },
  "header": {
    "configurationMenu": {
      "accountSettings": "Configuración de cuenta",
      "eventId": "Código QR - ID",
      "MyBooking": "Mis reservas",
      "myCertificates": "Mis Certificados",
      "surveys": "Encuestas",
      "courses": "Cursos"
    }
  },
  "event-id-qr": {
    "title": "IDENTIFICACIÓN DEL EVENTO",
    "ticket-label": "Tipo de ticket",
    "noData": "Tu no tienes una identificación QR para este evento",
    "error": {
      "title": "Error en el ID QR",
      "message": "Lo sentimos, no fue posible consultar los datos del codigo QR"
    }
  },
  "welcome": {
    "title": "Welcome to",
    "event": "Event Management system"
  },
  "login": {
    "loginTitle": "Inicio de sesión",
    "logout": "Cerrar sesión",
    "emailLabel": "Correo",
    "passwordLabel": "Contraseña",
    "rememberMe": "Recordarme",
    "loginButton": "INICIAR SESIÓN",
    "forgotPassword": "Olvidaste tu contraseña?",
    "passwordLabelConfirm": "Confirma contraseña",
    "signUp": "REGISTRARSE",
    "signIn": "Iniciar",
    "or": "o",
    "signUpSocial": "Regístrete con tu cuenta de redes sociales o dirección de correo electrónico",
    "signInSocial": "Inicia con tu cuenta de redes sociales o dirección de correo electrónico",
    "errorsLogin": {
      "invalidEmail": {
        "title": "Email no válido",
        "message": "No hemos podido autenticarte debido a que tu correo no es válido"
      },
      "userNotFound": {
        "title": "Usuario no encontrado",
        "message": "Verifica tu correo ó contraseña e intentalo de nuevo"
      },
      "wrongPassword": {
        "title": "Correo electrónico o contraseña incorrectas",
        "message": "No hemos podido autenticarte, verifica tu correo ó contraseña e intentalo de nuevo"
      },
      "accountExistsDifferentCredential": {
        "title": "Esta cuenta existe con una credencial diferente",
        "message": "No hemos podido autenticarte debido a que tu credencial ya tienen una cuenta de correo asignada"
      },
      "operationNotAllowed": {
        "title": "Acción no permitida",
        "message": "Esta funcionalidad no está habilitada para iniciar sesión"
      },
      "userDisabled": {
        "title": "Usuario deshabilitado",
        "message": "No hemos podido autenticarte debido a que tu cuenta está deshabilitada"
      },
      "invalidVerificationID": {
        "title": "ID de verificación inválido",
        "message": "No hemos podido autenticarte debido a que la verificación de su ID no es válido"
      },
      "domainConfigRequired": {
        "title": "Configuración de dominio requerida",
        "message": "La configuración de authDomain no ha sido realizada"
      },
      "popupCancelled": {
        "title": "Pop up cancelada",
        "message": "No hemos podido autenticarte debido a que se abrieron múltiples pantallas de inicio de sesión, por favor cierrelas e intente de nuevo"
      },
      "operationNotSupported": {
        "title": "Acción no soportada",
        "message": "No hemos podido autenticarte debido que no se cuenta con los protocolos de seguridad necesarios"
      },
      "popupBlocked": {
        "title": "Popup bloqueado",
        "message": "No hemos podido autenticarte debido a que el navegador a bloqueado la pestaña emergente de inicio de sesión"
      },
      "popupClosed": {
        "title": "Popup cerrado por usuario",
        "message": "No hemos podido autenticarte debido a que has cerrado la pestaña antes de completar el proceso."
      },
      "unauthorizedDomain": {
        "title": "Dominio no autorizado",
        "message": "Dominio no autorizado para iniciar sesión"
      },
      "providerAlreadyLinked": {
        "title": "Provedor vinculado",
        "message": "Error al registrarte debido a que este proveedor ya está vinculado a otro usuario"
      },
      "invalidCredential": {
        "title": "Credencial no válida",
        "message": "Error al registrarte debido a las credenciales son inválidas"
      },
      "credentialAlreadyUsed": {
        "title": "Credencial en uso",
        "message": "Error al registrarte debido a que su usuario ya está registrado"
      },
      "invalidVerificationCode": {
        "title": "Codigo de verificación inválido",
        "message": "Error al registrarse debido a que su código de verificación no es válido"
      },
      "emailAlreadyUsed": {
        "title": "Correo electrónico usado",
        "message": "Error al registrarte debido a ya existe una cuenta con el mismo correo electrónico registrado"
      },
      "weakPassword": {
        "title": "Contraseña débil",
        "message": "Error al registrarte debido a que la contraseña es muy insegura, por favor proporciona otra"
      },
      "defaultError": {
        "title": "Algo salió mal",
        "message": "Algo fallo, código de error:"
      }
    }
  },
  "drawer": {
    "alreadyAccount": "¿Ya tienes una cuenta?",
    "register": "Registrarse",
    "home": "Inicio",
    "welcomeMessage": "Mensaje de bienvenida",
    "speakers": "Ponentes",
    "hotelBooking": "Hospedaje",
    "program": "Programa",
    "abstracts": "Trabajos libres",
    "expo": "Expo",
    "contact": "Contacto",
    "checkout": "Realizar pago"
  },
  "home": {
    "seats": "Lugares",
    "greatsSpeakers": "Grandes ponentes",
    "noLocation": "No locación",
    "time": {
      "days": "Días",
      "hours": "Horas",
      "minutes": "Minutos",
      "seconds": "Segundos"
    },
    "homeView": {
      "january": "Enero",
      "february": "Febrero",
      "march": "Marzo",
      "april": "Abril",
      "may": "Mayo",
      "june": "Junio",
      "july": "Julio",
      "august": "Agosto",
      "september": "Septiembre",
      "october": "Octubre",
      "november": "Noviembre",
      "december": "Diciembre"
    }
  },
  "register": {
    "title": "Elige una categoría",
    "browseImage": "BUSCAR IMAGEN DE PERFIL",
    "registration": "REGISTRO",
    "register": "Registro",
    "changeImage": "CAMBIAR IMAGEN",
    "firstName": "Nombre(s)",
    "fullName": "Nombre completo",
    "lastName": "Apellido Paterno",
    "secondLastName": "Apellido Materno",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "ticketType": "Tipo de boleto",
    "submit": "Enviar",
    "disabledForm": "Botón deshabilitado, por favor llena todos los campos requeridos",
    "passwordDontMatch": "Las contraseñas no coinciden por favor inténtalo de nuevo",
    "eventInfo": "Información del evento",
    "accountComplete": "Completa tu cuenta",
    "continuePayment": "Continuar al pago",
    "genderTitle": "Genero",
    "birthday": "Fecha de nacimiento",
    "eventHasEnded": "El tiempo de registro para el evento ha terminado.",
    "ticketsNotAvailable": "Entradas no disponibles actualmente.",
    "profileImageSizeError": {
      "title": "Imagen demasiado pesada",
      "message": "La imagen debe ser menor a los 500kb"
    },
    "gender": {
      "male": "Masculino",
      "female": "Femenino",
      "other": "Other"
    },
    "payment": {
      "payment": "Pago",
      "yourTicket": "Tu ticket",
      "pay": "Pagar",
      "register": "Registrarse",
      "registerTitle": "Registro ",
      "registerMessage": "Para continuar con su registro, por favor de clic en el botón de registro.",
      "nameCard": "Nombre en la tarjeta",
      "cardNumber": "Número de tarjeta",
      "expirationDate": "Fecha de expiración",
      "paymentDialogTitle": "Proporcione los datos de su tarjeta",
      "errorMessages": {
        "incompleteNumber": "Número de tarjeta incompleto",
        "invalidNumber": "Número de tarjeta invalido",
        "incomplateExpiry": "Fecha de expiración incompleto",
        "invalidExpiry": "Fecha de expiración invalida",
        "incompleteCvc": "CVC incompleto"
      }
    },
    "registerError": {
      "title": "Algo salió mal",
      "message": "No fue posible registrar el participante"
    },
    "paymentError": {
      "title": "Algo salió mal",
      "message": "No fue posible realizar el pago"
    },
    "paymentErrorQuota": {
      "title": "Algo salió mal",
      "message": "Entradas no disponibles actualmente"
    },
    "paymentSuccess": {
      "title": "El pago realizado",
      "message": "La transacción se completo con éxito"
    },
    "wrongPasswordError": {
      "title": "Contraseña incorrecta",
      "message": "Este correo ya está usándose para algun otro evento, utiliza la misma contraseña para registrarte a este evento o cambia la dirección de correo electrónico"
    },
    "registerSuccess": {
      "title": "Datos registrados",
      "message": "Los datos ingresados fueron registrados exitosamente al evento:"
    },
    "registerSuccessUser": {
      "title": "Cuenta creada",
      "message": "La cuenta ha sido creada exitosamente."
    },
    "selectTicketTypeError": {
      "title": "Error al seleccionar ticket",
      "message": "No ha sido posible seleccionar un nuevo ticket"
    },
    "fileError": {
      "title": "Error",
      "message": "Error procesando archivo"
    },
    "formComplete": {
      "title": "Campos requeridos",
      "message": "Los campos son requeridos"
    },
    "ticketSelect": {
      "title": "El ticket es requerido",
      "message": "Selecciona un ticket"
    }
  },
  "recoveryPassword": {
    "title": "Iniciar sesión",
    "subtitle": "Olvidaste tu contraseña?",
    "description": "Ingresa el correo electrónico registrado y te enviaremos un link para que restablezcas tu contraseña.",
    "emailLabel": "Correo electrónico",
    "resetPasswordButton": "Restaurar contraseña",
    "resetPassword": "RESTABLECER CONTRASEÑA",
    "recoverySuccess": {
      "title": "Éxito",
      "message": "Correo de restablecimiento de contraseña enviado."
    },
    "erorCodeTitle": "Error al restablecer la contraseña",
    "erorCode": "Error en",
    "success": "Restauración exitosa",
    "successDescription": "La contraseña se restablecio correctamente",
    "erorConfirmTitle": "Error al confirmar la contraseña",
    "erorConfirm": "Las contraseñas no coinciden",
    "successConfirmTitle": "Confirmación de contraseña exitosa",
    "succesConfirm": "Las contraseñas coinciden"
  },
  "accountSettings": {
    "accountSettings": "Configuración de la cuenta",
    "profile": "Perfil",
    "resetPassword": "Recuperar contraseña",
    "name": "Nombre",
    "firstName": "Nombre(s)",
    "fullName": "Nombre completo",
    "lastName": "Apellido paterno",
    "secondLastName": "Apellido materno",
    "mail": "Correo",
    "edit": "EDITAR",
    "cancel": "CANCELAR",
    "save": "GUARDAR",
    "phoneNumber": "Número celular",
    "address": "Dirección",
    "description": "Descripción",
    "email": "Correo electrónico",
    "rules": {
      "name": "Por favor ingrese un nombre",
      "lastName": "Por favor ingrese el apellido paterno",
      "secondLastName": "Por favor ingrese el apellido materno",
      "phoneNumber": "Por favor ingrese un número de telefono",
      "phoneNumberLength": "Por favor ingrese 10 dígitos",
      "phoneNumberOnlyDigits": "Por favor ingrese solo dígitos",
      "address": "Por favor ingrese una dirección",
      "description": "Por favor ingrese una descripción"
    },
    "updateSuccess": {
      "title": "Éxito",
      "message": "Tu información ha sido actualizada."
    },
    "updateError": {
      "title": "Error",
      "message": "No ha sido posible actualizar tu información."
    },
    "updateImageSuccess": {
      "title": "Éxito",
      "message": "Tu imagen de perfil ha sido actualizada."
    },
    "updateImageError": {
      "title": "Error",
      "message": "No ha sido posible actualizar tu imagen de perfil."
    }
  },
  "welcomeMessage": {
    "title": "Mensaje de bienvenida",
    "seeMore": "Ver más",
    "greeting": "Queridos colegas y amigos:",
    "aboutEvent": "Acerca del evento"
  },
  "coupon": {
    "couponTitle": "¡Aplicar cupón!",
    "coupon": "¿Tienes un cupón? Ingresa el código a continuación",
    "apply": "Aplicar",
    "applyCoupon": "Aplicar Cupon!",
    "haveCoupon": "¿Tienes un cupón? ¡Por favor, aplíquelo a continuación!",
    "input": "Código de cupón",
    "noExist": "Cupón invalido",
    "noExistDetail": "El cupón no es valido",
    "invalidCoupon": "Cupon invalido",
    "invalidCouponDetail": "El cupón ha caducado o excedió el límite de usos",
    "validCoupon": "Cupón valido",
    "validCouponDetail": "El cupón fue aplicado correctamente",
    "errorCoupon": "Error",
    "errorCouponDetail": "Fallo al aplicar el cupón"
  },
  "footer": {
    "eventLocation": "Ubicación del evento",
    "contactUs": "Contáctanos",
    "email": "Correo: ",
    "phone": "Teléfono: ",
    "privacyPolicy": "Aviso de privacidad",
    "registrationCancellationPolicy": "Políticas de registro",
    "bookingCancellationPolicy": "Politícas de hospedaje",
    "poweredBy": "Desarrollado por "
  },
  "abstractsFound": "Aún no se ha publicado ninguna convocatoria",
  "hotels": {
    "hotelSelector": "Hotel",
    "hotelsAvailable": "Hoteles disponibles",
    "hotelBooking": "Reserva de hoteles",
    "hotelAddress": "Dirección",
    "hotelDescription": "Descripción",
    "hotelCommodities": "Características",
    "allInclusive": "Todo incluido",
    "complimentaryBreakfast": "Desayuno complementario",
    "airConditioning": "Aire acondicionado",
    "freeWifi": "WiFi gratis",
    "fitnessCenter": "Gimnasio",
    "parking": "Estacionamiento",
    "rules": "Reglas",
    "checkIn": "Entrada",
    "checkOut": "Salida",
    "rooms": "Habitaciones",
    "hotel": "hotel",
    "from": "desde",
    "night": "noche",
    "pickDate": "Selecciona una fecha",
    "guests": "Huéspedes",
    "adults": "Adulto(s)",
    "kid": "Niños(s)",
    "checkAvailability": "Buscar disponibilidad",
    "infoMessage": {
      "title": "Mensaje de información",
      "infoMessageCalendar": "El siguiente calendario es solo enunciativo y muestra las fechas en las que el hotel estará disponible. Sin embargo, no es posible seleccionar"
    },
    "obtainHotelInfoError": {
      "title": "Error al obtener la información del hotel",
      "message": "No fue posible obtener la información del hotel"
    },
    "errorAvailability": {
      "title": "Error al revisar la disponibilidad",
      "message": "No fue posible revisar la disponibilidad"
    },
    "errorSaveBooking": {
      "title": "Error al realizar la reservación",
      "message": "No fue posible realizar la reservación"
    },
    "errorAddBooking": {
      "title": "Error al agregar la reservación",
      "message": "No fue posible agregar la reservación"
    },
    "errorPayBooking": {
      "title": "Error con el pago",
      "message": "No ha sido posible realizar el pago"
    },
    "room": {
      "roomDescription": "Descripción",
      "price": "Precio",
      "perNight": "/noche",
      "taxesNotIncluded": "(Impuestos no incluidos)",
      "roomCommodities": "Características",
      "additionalInfo": "Información adicional",
      "makeReservation": "Realizar una reservación",
      "datesAvailable": "Fechas disponibles",
      "obtainRoomInfoError": {
        "title": "Error al obtener la información de la habitación",
        "message": "No fue posible obtener la información de la habitación"
      }
    },
    "book": "Reservar",
    "availableSearch": "Disponibilidad para tu busqueda",
    "forOnly": "Desde",
    "availableValidate": "No hay disponible de cuartos para las fechas seleccionadas",
    "bookingCheckout": {
      "hotelBooking": "RESERVA DE HOTEL",
      "payment": "Pago",
      "checkIn": "Entrada",
      "checkOut": "Salida",
      "nights": "noches",
      "rooms": "habitaciones",
      "averageRate": "Precio promedio por noche",
      "taxes": "Impuestos",
      "taxesFees": "Impuestos y honorarios",
      "subtotal": "Subtotal",
      "IVA": "IVA",
      "includingTaxes": "Incluidos impuestos y tarifas",
      "pay": "Pagar",
      "for": "Para",
      "guest": "personas",
      "additionalComments": "Comentarios adicionales",
      "additionalFields": "Campos adicionales",
      "addCompanion": "Agregar acompañante",
      "guestInformation": "Información del huesped",
      "myBooking": "Mi reservación",
      "paymentMethod": "Método de pago",
      "rules": {
        "email": "Correo electronico requerido"
      }
    }
  },
  "bookings": {
    "title": "RESERVACIÓN HOTEL",
    "subtitle": "Mis reservaciones",
    "currentBookings": "Reservaciones actuales",
    "bookingID": "ID de Reservación:",
    "roomCapacity": "Capacidad del cuarto",
    "bedType": "Tipo de cama",
    "capacityAdults": "adultos",
    "capacityChildren": "niños",
    "bookingDate": "Fecha de reservación",
    "contactUs": "Problemas? Contáctanos",
    "hotelName": "Nombre del hotel",
    "additionalComments": "Comentarios adicionales",
    "active": "Activo",
    "canceled": "Cancelado",
    "status": "Estado",
    "bookingStatus": {
      "paid": "Pagado",
      "cancelled": "Cancelado",
      "pending": "Pendiente"
    }
  },
  "reservationDetails": {
    "hotelBooking": "RESERVA DE HOTEL",
    "yourReservations": "Tus reservaciones",
    "checkIn": "Entrada",
    "checkOut": "Salida",
    "adult": "Adultos",
    "child": "Niños",
    "night": "Noches",
    "room": "Habitación",
    "rooms": "Habitaciones",
    "price": "Precio",
    "taxesNotIncluded": "impuestos no incluidos",
    "hintTaxes": "Los impuestos se mostrarán en la página de checkout",
    "goCheckout": "PAGAR"
  },
  "expo": {
    "downloadPicture": "Descargar imagen",
    "notFound": "No se encontraron archivos adjuntos"
  },
  "speakers": {
    "main": "Mesa directiva",
    "title": "Ponentes",
    "notFound": "Ponentes no encontrados",
    "loading": "Cargando Ponentes",
    "viewMore": "Ver mas"
  },
  "sponsors": {
    "title": "Patrocinadores oficiales",
    "platinum": "Platinum",
    "gold": "Gold",
    "silver": "Silver",
    "obtainSponsorsInfoError": {
      "title": "Error al obtener la información de los patrocinadores",
      "message": "No fue posible obtener la información de los patrocinadores"
    }
  },
  "program": {
    "fullProgram": "ver programa completo",
    "events": "Eventos",
    "program": "Programa",
    "day": "Día",
    "register": "Registrarse a esta actividad",
    "btnDownload": "Descargar programa",
    "messages": {
      "getProgramErrorTitle": "¡Algo salió mal!",
      "getProgramErrorMessage": "¡Lo lamentamos! En este momento no podemos obtener el programa. Intente de nuevo más tarde"
    },
    "warning": "Advertencia",
    "cancel": "Cancelar",
    "continue": "Continuar",
    "message": "El evento seleccionado actualmente se encuentra en curso,  ¿Quiere continuar con el pago?.",
    "registerCourse": {
      "register": "Registrarse",
      "coursePayment": "Pago del curso",
      "course": "Curso",
      "speaker": "Ponente",
      "description": "Descripción",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha de finalización",
      "from": "De",
      "to": "a",
      "pay": "Pagar",
      "courseDates": "Fechas del curso",
      "date": "Fecha",
      "hours": "Hora",
      "registerSuccess": {
        "title": "Éxito",
        "message": "Se ha registrado exitosamente al curso"
      },
      "registerError": {
        "title": "Algo salió mal",
        "message": "No fue posible registrarse al curso"
      },
      "alreadyRegisteredError": {
        "title": "Ya registrado",
        "message": "Ya se ha registrado en el curso"
      },
      "soldOutError": {
        "title": "Agotado",
        "message": "El cupo se ha agotado"
      }
    },
    "courses": {
      "courses": "Cursos",
      "coursesAndCertificates": "Cursos y Certificados",
      "courseDate": "Horario del curso",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha final",
      "streamingURL": "Transmisión del evento",
      "evaluate": "Evaluación",
      "downloadCertificate": "Descarga el certificado",
      "cost": "Costo",
      "freeCourse": "Curso sin costo",
      "eventDate": "Fecha del evento",
      "eventEntry": "Entrada de evento",
      "certificateNotAvailable": "Certificado no disponible",
      "errorCheckEntranceEventMessage": {
        "title": "Error al verificar el registro de entrada",
        "message": "Lo sentimos, no se ha verificado la entrada del evento"
      },
      "errorDownloadCertificate": {
        "title": "Certificado no disponible",
        "message": "Lo sentimos, no fue posible descargar el certificado"
      }
    }
  },
  "participant": {
    "messages": {
      "getParticipantErrorTitle": "¡Error al obtener el participante!",
      "getParticipantErrorMessage": "¡Lo lamentamos! El participante no fue encontrado."
    }
  },
  "abstract": {
    "mainAuthor": "Autor principal",
    "coAuthors": "Co-Autores",
    "abstract": "Resúmen",
    "apply": "Aplicar",
    "abstractTitle": "Resúmenes",
    "fullName": "Nombre Completo",
    "institution": "Instituto",
    "coName": "Nombre(s)",
    "coLastName": "Apellido(s)",
    "coCountry": "Estado",
    "coCity": "Ciudad",
    "title": "Titulo",
    "format": "Formato en el que desea presentar su trabajo",
    "summary": "Resumen y objetivos",
    "method": "Material y métodos",
    "result": "Resultados",
    "discussion": "Discusión",
    "conclusion": "Conclusiones",
    "bibliography": "Bibliografía",
    "validateForm": "Botón desactivado, complete todos los campos obligatorios",
    "validateFormCo": "Botón activado, recuerde hacer clic para guardar",
    "verLogin": "Verifique que haya iniciado la sesión",
    "verRegistro": "Registrarse en el evento",
    "verPay": "Completar el pago",
    "mensaje": "La funcionalidad de esta ventana no se puede realizar por una (s) de las siguientes razones:",
    "send": "Enviar",
    "support": "Los archivos PDF en línea no son compatibles con este navegador",
    "download": "Descargar",
    "pdfInstructions": "Sube tu documento, solo acepta archivos de tipo; .pdf.",
    "titleCoAuthores": "Co-Author #",
    "nameFileDefault": "Ningún archivo elegido",
    "fileDefault": "Seleccionar archivo",
    "solicitudSuccess": {
      "title": "Solicitud registrada",
      "message": "La solicitud se registró correctamente en el evento:"
    },
    "solicitudError": {
      "title": "Algo salió mal",
      "message": "No se pudo realizar la solicitud"
    }
  },
  "dialogContinuePay": {
    "title": "Pago Requerido",
    "message": "Estimado(a)  usuario(a), le informamos que su pago al evento aun no ha sido completado. Recuerde que para tener acceso a los servicios especiales del evento es necesario completar este proceso. Le invitamos a ponerse al día con su pago dando clic en el botón Pagar.",
    "logoutButton": "Cerrar sesión",
    "checkoutButton": "Pagar"
  },
  "survey": {
    "title": "Encuesta"
  },
  "bottomNavigation": {
    "bookings": "Reservaciónes",
    "courses": "Cursos",
    "billing": "Facturación"
  },
  "contactUsMessage": "¿Problemas? Contactanos",
  "downloadQR": "Descargar QR",
  "billing": {
    "myAccount": "Mi cuenta",
    "billing": "Facturación",
    "myPurchases": "Mis compras",
    "eventEntry": "Entrada de evento",
    "course": "Curso",
    "hotel": "Hotel",
    "downloadReceipt": "Descargar Recibo",
    "downloadInvoice": "Descargar factura",
    "requestInvoice": "Solicitud de factura",
    "invoiceRequested": "Factura solicitada",
    "nofound": "No se encontraron facturas",
    "noMore": "No se encontraron más facturas",
    "load": "Carga más",
    "formComplete": "Completa todos los campos",
    "invoiceRequestedMore": "Su solicitud está en proceso, podrá descargar su factura dentro de las 72 hrs.",
    "billingProcessing": "Los datos para solicitar la factura se están procesando. Por favor, espere un momento.",
    "rules": {
      "pName": "Se requiere el nombre del participante",
      "email": "Correo electronico es requerido",
      "socialR": "Se requiere la razon social",
      "RFC": "Se requiere RFC",
      "rfcLength": "Se requiere RFC debe tener 13 dígitos",
      "direction": "Se requiere dirección",
      "city": "Se requiere ciudad",
      "state": "Se requiere estado",
      "cp": "Se requiere código postal",
      "cpLength": "El código postal debe tener 5 dígitos",
      "fiscalR": "Se requiere régimen fiscal",
      "CFDI": "Se requiere uso de CFDI"
    },
    "form": {
      "pName": "Nombre del participante",
      "email": "Correo electrónico",
      "socialR": "Razon social (sin el régimen capital, tal cual aparece en la cédula fiscal, en mayúsculas)",
      "direction": "Dirección",
      "city": "Ciudad",
      "state": "Estado",
      "fiscalR": "Régimen fiscal",
      "CFDI": "Uso de CFDI",
      "send": "Enviar petición"
    },
    "messages": {
      "errorGet": "Error al obtener facturación",
      "errorInvoice": "Error al solicitar Factura",
      "error": "Error en la facturación",
      "successRequest": "Facturación solicitada",
      "successRequestMS": "Solicitud de facturación exitosa"
    },
    "taxRegime": {
      "601": "General de Ley Personas Morales",
      "603": "Personas Morales con Fines no Lucrativos",
      "605": "Sueldos y Salarios e Ingresos Asimilados a Salarios",
      "606": "Arrendamiento",
      "607": "Régimen de Enajenación o Adquisición de Bienes",
      "608": "Demás ingresos",
      "610": "Residentes en el Extranjero sin Establecimiento Permanente en México",
      "611": "Ingresos por Dividendos (socios y accionistas)",
      "612": "Personas Físicas con Actividades Empresariales y Profesionales",
      "614": "Ingresos por intereses",
      "615": "Régimen de los ingresos por obtención de premios",
      "616": "Sin obligaciones fiscales",
      "620": "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
      "621": "Incorporación Fiscal",
      "622": "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
      "623": "Opcional para Grupos de Sociedades",
      "624": "Coordinados",
      "625": "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
      "626": "Régimen Simplificado de Confianza"
    },
    "CFDI": {
      "G02": "Devoluciones, descuentos o bonificaciones.",
      "G03": "Gastos en general.",
      "D01": "Honorarios médicos, dentales y gastos hospitalarios.",
      "D04": "Donativos.",
      "D06": "Aportaciones voluntarias al SAR.",
      "D07": "Primas por seguros de gastos médicos.",
      "D10": "Pagos por servicios educativos (colegiaturas).",
      "S01": "Sin efectos fiscales.",
      "CP01": "Pagos",
      "CN01": "Nómina"
    }
  },
  "InstructionsCall": "Para cancelar su registro a este evento, llame al: ",
  "Call": "Llamar",
  "cardRegister": {
    "register": "Por favor ingrese su información",
    "description": "Si no tienes cuenta puedes agregar tu información y continuar con la reservación",
    "errorPW": "Las contraseñas no coinciden. Revise que ambas sean iguales.",
    "save": "GUARDAR"
  }
}